import { Asset } from '@tassat/fred-definitions';

export type AssetWithCurrency = Asset & {
    Currency: Asset;
};

export type AssetWithPrice = Asset & {
    Price?: string;
};

export type SecurityCurrencyAssetPair = {
    security?: Asset;
    currency?: Asset;
};

export enum AssetTicker {
    USD = 'USD',
    TFND = 'TFND',
    FTIXX = 'FTIXX'
}

export enum AllowedTransactionType {
    Deposit = 'D',
    Transfer = 'X',
    Withdrawal = 'W',
    Buy = 'B',
    Sell = 'S',
    Subscribe = 'U',
    Redeem = 'R',
    InterestDistribution = 'I',
    Netting = 'N',
    Collateral = 'C'
}